<template>
  <div class="pay_cont creditcard target_apaycreditcard">
    <div class="row card-method">
      <div id="paymentPanel02">
        <div class="swiper mySwiper card-swiper type-gray">
          <div class="swiper-wrapper" v-if="haveCard">
            <Flicking
              :key="selectedParty"
              ref="cardFlicking"
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
              @changed="onSlideChange"
              @select="onSlideSelect"
              @ready="onSwiperReady"
            >
              <card-slider
                v-for="(card, index) in cards"
                :key="index"
                :class="index === activeIndex ? 'swiper-slide-active' : ''"
                :card="card"
              />
              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>
          <div class="swiper-wrapper" v-else>
            <Flicking
              :key="selectedParty"
              ref="cardFlicking"
              class="flicking-camera"
              :plugins="plugins"
              :options="swiperOptions"
              @ready="onSwiperReady"
            >
              <div
                class="swiper-slide"
                style="width: 302px !important; padding: 0 8px"
              >
                <div class="payment-unit">
                  <a class="payment-link">
                    <div class="payment-card card-area">
                      <p>
                        등록된 A Pay 계좌/카드가 없습니다.<br />
                        암웨이 홈페이지에서 등록 후 사용해주세요.
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <span slot="viewport" class="swiper-button-prev"></span>
              <span slot="viewport" class="swiper-button-next"></span>
            </Flicking>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardSlider from "@/views/order/main/components/Payment/CardSlider";
import { Flicking } from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
import { Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";
import { log } from "@/utils/common";
import { mapGetters } from "vuex";
import { AMWAY_PAY_METHODS } from "@/utils/constants";

export default {
  name: "AmwayPayCard",
  components: {
    CardSlider,
    Flicking,
  },
  props: {
    amwayPayCards: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      paymentInfo: "payment/paymentInfo",
      selectedParty: "amwaypay/selectedParty",
    }),
    cards() {
      return this.selectedParty === 0
        ? this.amwayPayCards.masterParty
        : this.amwayPayCards.subParty;
    },
    haveCard() {
      return this.cards.length > 0;
    },
  },
  data() {
    return {
      plugins: [
        new Arrow({
          prevElSelector: ".swiper-button-prev",
          nextElSelector: ".swiper-button-next",
        }),
      ],
      activeIndex: 0,
      swiperOptions: {
        align: "center",
        circular: false,
        panelsPerView: -1,
        noPanelStyleOverride: false,
      },
    };
  },
  mounted() {
    // if(!this.haveCard) {
    //   console.log("reset account");
    //   this.$store.commit('amwaypay/resetAmwayPay');
    // }

    const paymentInfo = this.paymentInfo;
    const paymentMode = paymentInfo.paymentMode;
    const paymentCode = paymentInfo.paymentCode;

    console.log("mounted AmwayPayCard");
    console.log("paymentMode : ", paymentMode);
    console.log("paymentCode : ", paymentCode);

    if (paymentMode == AMWAY_PAY_METHODS.CARD) {
      if (!!paymentCode) {
        let index = -1;
        index = this.amwayPayCards.masterParty.findIndex(
          (card) => card.methodKey == paymentCode
        );
        if (index > -1) {
          this.activeIndex = index;
          this.$store.commit("amwaypay/updateSelectedParty", 0);
          return;
        }

        index = this.amwayPayCards.subParty.findIndex(
          (card) => card.methodKey == paymentCode
        );
        if (index > -1) {
          this.activeIndex = index;
          this.$store.commit("amwaypay/updateSelectedParty", 1);
          return;
        }
        // if(index == -1) {
        //   this.$store.commit('amwaypay/resetAmwayPay');
        // }
      }
    }
  },
  methods: {
    onSlideChange(data) {
      console.log("Card onSlideChange : ", data);
      this.activeIndex = data.index;
      this.chooseCard(this.activeIndex);
    },
    onSlideSelect(data) {
      console.log("Card onSlideSelect : ", data);
      this.activeIndex = data.index;
      data.panel.focus(300);
      this.chooseCard(this.activeIndex);
    },
    onSwiperReady(event) {
      console.log("Card onSwiperReady : ", event);
      this.$refs.cardFlicking.moveTo(this.activeIndex);
      this.chooseCard(this.activeIndex);
    },
    chooseCard(index) {
      console.log("chooseCard : ", index);
      const selectedCard = this.cards[index];
      this.$store.commit("amwaypay/selectAmwayPayCard", selectedCard);
      log("chooseCard:: ", selectedCard);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/composition/payment/AmwayPayCard.vue